<template>
	<div class="tpl chatting-wrap">
		<mt-header title="鱼水缘" fixed>
		  <router-link :to="{name:fromPath.name}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button class="add-friend-btn" @click.native="addFriend()" icon="more" slot="right"></mt-button>
		</mt-header>
		<a href="##">
			<img src="../../assets/img/chats/chatting.png"/>
		</a>
	</div>
</template>
<script>
	export default{
		name:"chatting",
		data(){
			return{
				fromPath:"",	//来源路由
			}
		},
		created(){
			this.$store.commit("changeTabChoosed","chats");
			this.$store.commit("changeTabBarShow",false);
		},
		beforeRouteEnter (to, from, next) {
            next((vm)=>{ //参数vm就是当前组件的实例。
                vm.fromPath = from;
                console.log(vm.fromPath)
            })
		},
	}
</script>
<style scoped>
	#app .mint-header{
		height: 3rem;
	}
	img{
		width: 100%;
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/components/Chats/Chatting.vue